// ProductPage.style.ts

import styled from 'styled-components';


export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed; /* ESSENCIAL PARA ALINHAR COLUNAS */
`;

export const TableHead = styled.thead`
  background-color: #f5f5f5; /* Fundo cinza para o cabeçalho */

  tr {
    border: #f5f5f5 solid;
  }

  th {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    padding: 12px;
    color: #696969;
    /* Adicione larguras fixas (ou percentuais) para cada coluna do cabeçalho */
    /* ESTES VALORES SÃO CRUCIAIS E DEVEM SER AJUSTADOS POR VOCÊ PARA ALINHAR PERFEITAMENTE */
    /* Sugestão de ajuste: use px para colunas pequenas e % para as que precisam esticar */
    &:nth-child(1) { width: 60px; } /* Coluna do Switch */
    &:nth-child(2) { width: 100px; } /* Código */
    &:nth-child(3) { width: 15%; } /* Produto */
    &:nth-child(4) { width: 10%; } /* Família */
    &:nth-child(5) { width: 10%; } /* Tipo */
    &:nth-child(6) { width: 20%; } /* Cores */
    &:nth-child(7) { width: 15%; } /* Graduação */
    &:nth-child(8) { width: 120px; } /* Preço */
    &:nth-child(9) { width: 100px; } /* Ações (ícones) */
  }
`;


export const TableRow = styled.tr`
  border-bottom: 1.5px solid #f3f3f3;
  td {
    background-color: #ffffff; /* Fundo branco para as células de dados */
  }
`;

export const TableCell = styled.td`
  padding: 12px 8px;
  text-align: left;
  vertical-align: middle;

  /* Aplica as mesmas larguras das colunas do cabeçalho para as células do corpo */
  /* Isso garante o alinhamento perfeito */
  &:nth-child(1) { width: 60px; } /* Coluna do Switch */
  &:nth-child(2) { width: 100px; } /* Código */
  &:nth-child(3) { width: 15%; } /* Produto */
  &:nth-child(4) { width: 10%; } /* Família */
  &:nth-child(5) { width: 10%; } /* Tipo */
  &:nth-child(6) { width: 20%; } /* Cores */
  &:nth-child(7) { width: 15%; } /* Graduação */
  &:nth-child(8) { width: 120px; } /* Preço */
  &:nth-child(9) { width: 100px; } /* Ações (ícones) */
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const PageContainer = styled.div`
  padding: 16px;
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const LoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  padding: 10px 20px;
  border: 1px solid #009DFF;
  border-radius: 25px;
  background-color: #fff;
  color: #009DFF;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;


  &:hover {
    background-color: #e6f2ff;
    border-color: #009DFF;
    color: #009DFF;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    filter: invert(30%) sepia(90%) saturate(1500%) hue-rotate(190deg) brightness(90%) contrast(90%);
  }
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  margin-left: 32px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const FilterButton = styled.button`
  background-color: white;
  border: 1px solid #009DFF;
  color: #009DFF;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const NewProductButton = styled.button`
  background-color: #009DFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;

// Container para o cabeçalho da tabela separado
export const TableHeaderContainer = styled.div`
  background-color: #ffffff; /* Fundo branco para a área que contém o cabeçalho */
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 0;
  margin-bottom: -1px; /* Para que o header "grude" na tabela abaixo */
  position: relative;
  z-index: 2; /* Garante que o cabeçalho fique acima */

  ${Table} {
    margin-bottom: 0;
    border-bottom: none;
  }

  ${TableHead} {
    background-color: #f5f5f5; /* Fundo cinza claro para o cabeçalho */
    position: static;
    top: auto;
    z-index: auto;
    border-radius: 0;
  }

  ${TableRow} {
    border-bottom: 1.5px solid #f3f3f3; /* Linha divisória do cabeçalho */
  }

  ${TableCell} {
    background-color: #f5f5f5; /* Garante que as células do cabeçalho sejam cinza */
  }
`;

export const TableWrapper = styled.div`
  background-color: #ffffff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 0;
  overflow-x: auto;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05); /* Sombra apenas na caixa principal da tabela */

  /* Assegura que o TableWrapper se ajuste ao conteúdo, sem altura mínima forçada */
  /* Remove flex-grow e alturas fixas ou máximas */
  min-height: 0; /* Permite que o container encolha ao mínimo necessário */
  height: auto; /* Deixa a altura ser definida pelo conteúdo */
  max-height: calc(100vh - 250px); /* Define uma altura máxima para a rolagem, mas só ativa se o conteúdo exceder */
                                   /* Este valor (250px) AINDA PRECISA SER AJUSTADO por você. */
                                   /* Ele deve ser a altura total de todos os elementos acima da tabela + a margem do botão "Carregar mais" */

  overflow-y: auto;   /* Habilita o scroll vertical APENAS dentro desta div, se o conteúdo exceder max-height. */
  overflow-x: hidden; /* Oculta scroll horizontal. */

  /* Estilos específicos para a Table dentro do TableWrapper */
  ${Table} {
    margin-top: -1px; /* Remove borda superior para não duplicar com o header */
    border-top: none;
  }

  ${TableHead} {
    display: none; /* Oculta o thead original que estaria aqui (agora vazio) */
  }
`;